import { render, staticRenderFns } from "./CreateOriginalSample.vue?vue&type=template&id=ce591fe6&scoped=true&"
import script from "./CreateOriginalSample.vue?vue&type=script&lang=js&"
export * from "./CreateOriginalSample.vue?vue&type=script&lang=js&"
import style0 from "./CreateOriginalSample.vue?vue&type=style&index=0&id=ce591fe6&prod&scoped=true&lang=css&"
import style1 from "./CreateOriginalSample.vue?vue&type=style&index=1&id=ce591fe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce591fe6",
  null
  
)

export default component.exports